import { InitialConfigType, LexicalComposer } from '@lexical/react/LexicalComposer';
import { activityLogIcon, GRAY_SQUARE_ICON, VERTICAL_LINE_ICON } from 'constants/envelopeIcons';
import React, { useState } from 'react';
import ReactMarkdown from 'react-markdown';
import { RenderedAction } from 'types';
import LoadHtmlPlugin from 'utils/lexical/LoadHtmlPlugin';

type LogItemProps = {
  log: RenderedAction;
  index: number;
  length: number;
};
type IconKey = keyof typeof activityLogIcon;

const LogItem: React.FC<LogItemProps> = (props) => {
  const { log, index, length } = props;
  const [textContent, setTextContent] = useState('');

  const icon = activityLogIcon[log.icon as IconKey] ?? GRAY_SQUARE_ICON;

  const commentConfig: InitialConfigType = {
    namespace: 'comment-action',
    editable: false,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onError: (error: any): void => {
      throw error;
    },
  };

  return (
    <div className="w-full mr-3">
      <div className="flex justify-between items-center">
        <div className="flex justify-start items-center">
          <div className="w-5">{icon}</div>
          <div className="text-md py-1 ml-4">
            <ReactMarkdown>{log.title}</ReactMarkdown>
          </div>
        </div>
      </div>
      <div className="w-full flex">
        {index + 1 < length && length > 1 ? (
          <div>{VERTICAL_LINE_ICON}</div>
        ) : (
          <div className="w-5" />
        )}
        {log.type === 'comment' ? (
          <div className="w-full flex items-center overflow-hidden">
            <span className="w-full ml-4 truncate text-small">{textContent}</span>

            <LexicalComposer initialConfig={commentConfig}>
              <LoadHtmlPlugin
                edited={false}
                content={log.description || ''}
                setTextContent={setTextContent}
              />
            </LexicalComposer>
          </div>
        ) : (
          <ReactMarkdown
            className={`ml-4 flex items-center text-small overflow-hidden ${
              log.icon === 'comment' ? 'comment-log' : ''
            }`}
          >
            {log.description}
          </ReactMarkdown>
        )}
      </div>
    </div>
  );
};

export default LogItem;
